import { jsx as t, jsxs as r, Fragment as a } from "react/jsx-runtime";
import { ar as n } from "../../../vendor-CPVnY93G.js";
import { ItemRow as o } from "../../ItemRow/index.js";
import '../../../assets/index50.css';const s = "_selectItem_1ntdm_1", i = {
  selectItem: s
}, p = ({ item: e, ...c }) => /* @__PURE__ */ t(o, { as: n, ...c, textValue: e.label, className: i.selectItem, children: ({ selectionMode: l }) => /* @__PURE__ */ r(a, { children: [
  e.decorationLeft ? /* @__PURE__ */ t(o.DecorationLeft, { ...e.decorationLeft }) : null,
  /* @__PURE__ */ t(o.Label, { children: e.label }),
  /* @__PURE__ */ t(o.Description, { children: e.description }),
  e.decorationRight ? /* @__PURE__ */ t(o.DecorationRight, { ...e.decorationRight }) : null,
  !!l && /* @__PURE__ */ t(o.Selectable, {})
] }) });
export {
  p as SelectItem
};
